import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'
import { useEffect, useRef, useState } from 'react'

import { useConfirmEmailChange } from '../../../api'
import { AuthLayout, ConfirmEmailChange, ConfirmEmailChangeStatus } from '../../../components'

export interface ConfirmEmailChangePageProps {
  token: string
}

export function ConfirmEmailChangePage({ token }: ConfirmEmailChangePageProps) {
  const { execute } = useConfirmEmailChange()
  const [status, setStatus] = useState<ConfirmEmailChangeStatus>(
    ConfirmEmailChangeStatus.PROCESSING
  )
  const [email, setEmail] = useState<string | null>(null)
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (hasFiredRef.current) return
    hasFiredRef.current = true

    let cancelled = false
    ;(async () => {
      const result = await execute(decodeURIComponent(token))
      if (cancelled) return

      if (result.success) {
        setEmail(result.email)
        setStatus(ConfirmEmailChangeStatus.SUCCESS)
      } else {
        setStatus(ConfirmEmailChangeStatus.ERROR)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [execute, token])

  return (
    <AuthLayout>
      <ConfirmEmailChange status={status} email={email} />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  ctx.res?.setHeader('Cache-Control', 'no-cache, no-transform')
  ctx.res?.setHeader('X-Robots-Tag', 'noindex')

  const token = ctx.params?.token as string | undefined
  if (!token) {
    return { notFound: true }
  }

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      token,
    },
  }
}

export const ConfirmEmailChangePageExports = {
  getServerSideProps,
}
